import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-user-analytics',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    {
      provide: TabComponent,
      useExisting: UserAnalyticsComponent,
    },
  ],
  templateUrl: './user-analytics.component.html',
  styleUrl: './user-analytics.component.scss',
})
export class UserAnalyticsComponent extends TabComponent {
  override name: string = this.dictionaryService.get('UserAnalytics');

  public async main(): Promise<void> {}
}
